(function(){
    'use strict'

    angular.module('app.devengados')
    .factory('TiposDevengadosService', TiposDevengadosService);

    TiposDevengadosService.$inject = ['$http', '$q', 'apiSettings'];

    function TiposDevengadosService($http, $q, apiSettings) {

        var api = {
            getAll: getAll
        };

        return api;

        function getAll(){

            var url = apiSettings.apiBaseUrl + 'api/tipos-deduccion';
            
            return $http.get(url)
            .then(getAllSuccess, getAllError);

            function getAllSuccess(response){
                return response.data;
            };

            function getAllError(error) {
                return $q.reject(error);
            }
        };

    };

})();        